/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import 'echarts/lib/chart/line';
import 'echarts/lib/chart/scatter';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
import 'echarts/lib/component/legend';
import 'echarts/lib/component/grid';
import 'echarts/lib/component/dataZoom';
import 'echarts/lib/component/visualMap';
import echarts from 'echarts/lib/echarts';
import { connect } from 'react-redux';
import styles from './styles.scss';

const defaultProps = {
  legend: [],
  grid: null,
  xAxis: null,
  yAxis: null,
  dataZoom: null,
  tooltip: {},
  resize: null,
  collapsed: false,
  visualMap: null,
  colorShift: 0,
  height: $(window).height() / 2,
};
const propTypes = {
  series: React.PropTypes.array.isRequired,
  legend: React.PropTypes.any,
  grid: React.PropTypes.any,
  xAxis: React.PropTypes.any.isRequired,
  yAxis: React.PropTypes.any.isRequired,
  visualMap: React.PropTypes.any.isRequired,
  tooltip: React.PropTypes.object,
  dataZoom: React.PropTypes.any,
  colorShift: React.PropTypes.number,
  height: React.PropTypes.number,
};

class ScatterChart extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      series: props.series,
      legend: props.legend,
    };
    this.tryResizeChart = this.tryResizeChart.bind(this);
  }

  componentDidMount() {
    this.echart = this.initChart();
    this.echart.resize();
    $(window).resize(this.tryResizeChart);
  }

  componentWillReceiveProps(nextProps) {
    const { series, legend } = nextProps;
    if (series !== this.props.series) {
      this.updateChart(series, legend);
      this.setState({
        series: nextProps.series,
        legend: nextProps.legend,
      });
    }
    this.tryResizeChart();
  }

  componentWillUnmount() {
    echarts.dispose($(this.chartRef));
    $(window).off('resize', this.tryResizeChart);
  }

  colors() {
    const { colorShift } = this.props;
    if (colorShift > 0) {
      return _.concat(
        _.drop(ScatterChart.colors, colorShift),
        _.take(ScatterChart.colors, colorShift),
      );
    }
    return ScatterChart.colors;
  }

  tryResizeChart() {
    const width = $(this.chartRef).width();
    const height = $(this.chartRef).height();
    if (height !== this.height || width !== this.width) {
      if (this.echart) {
        this.echart.resize();
      }
    }
    this.width = width;
    this.height = height;
  }

  updateChart(nextSeries) {
    const { legend, visualMap } = this.props;
    const { series: thisSeries } = this.state;
    const series = nextSeries.map(s => (
      _.extend({
        type: 'scatter',
      }, s)
    ));
    const option = {
      ...this.echart.getOption(),
      visualMap,
      series,
      legend,
    };
    if (!_.isEqual(
          _.map(thisSeries, 'name'),
          _.map(nextSeries, 'name'))) {
      // reset option
      this.echart.clear();
    }
    this.echart.setOption(option);
    this.echart.resize();
  }

  initChart() {
    const echart = echarts.init(this.chartRef);
    const series = this.state.series.map(s => ({
      name: s.name,
      data: s.data,
      type: 'scatter',
    }));

    const { legend, grid, visualMap, dataZoom, tooltip, xAxis, yAxis } = this.props;
    const option = {
      dataZoom,
      xAxis,
      yAxis,
      legend,
      series,
      visualMap,
      grid,
      color: this.colors(),
      textStyle: {
        fontSize: 12,
        fontWeight: 300,
      },
      tooltip: {
        ...tooltip,
      },
      animationEasing: 'cubicIn',
      showLoading: true,
    };
    echart.setOption(option);
    return echart;
  }

  render() {
    const { height } = this.props;

    return (
      <div
        className={styles.chart}
        style={{ height }}
        ref={(ref) => { this.chartRef = ref; }}
      />
    );
  }
}

ScatterChart.colors = [
  '#22A7F0',
  '#00B16A',
  '#F7CA18',
  '#F9690E',
  '#EF4836',
  '#DB0A5B',
  '#663399',
  '#BF55EC',
  '#446CB3',
  '#336E7B',
  '#1BBC9B',
];
ScatterChart.propTypes = propTypes;
ScatterChart.defaultProps = defaultProps;

const mapStateToProps = state => ({
  collapsed: state.sidebar.collapsed,
});

export default connect(mapStateToProps, null)(ScatterChart);




// WEBPACK FOOTER //
// ./src/components/ScatterChart/index.jsx